import { render, staticRenderFns } from "./VrsteOdrzavanja.vue?vue&type=template&id=f5f94740&scoped=true&"
import script from "./VrsteOdrzavanja.vue?vue&type=script&lang=ts&"
export * from "./VrsteOdrzavanja.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5f94740",
  null
  
)

export default component.exports